import { useEffect, useRef, useState } from "react";
import { Button, Checkbox, message, Select, Table } from "antd";
import { serverFetch } from "../../../server";
import MessagePattern from "./message-pattern";
import { getMessagePatternVidName } from "./message-pattern-vids";
import { RefreshButton } from "../../../extensions/design";

const MessagePatterns = () => {
  const [items, setItems] = useState([]);
  const [companies, setCompanies] = useState([]);
  const [loading, setLoading] = useState(false);
  const [editId, setEditId] = useState(null);
  const [filter, setFilter] = useState({ companyId: null, showHidden: false });
  const divRef = useRef(null);

  const getData = () => {
    setLoading(true);
    const params = filter.companyId ? `?companyId=${filter.companyId}` : "";
    serverFetch(`MessagePattern${params}`)
      .then((data) => {
        setItems(Array.isArray(data) ? data : []);
        setLoading(false);
      })
      .catch((e) => {
        setLoading(false);
        message.error(e.userMessage);
      });
  };

  const getCompanies = () => {
    serverFetch("company")
      .then((data) => setCompanies(data ?? []))
      .catch((e) => message.error(e.userMessage));
  };

  useEffect(getCompanies, []);
  useEffect(getData, [filter.companyId]);

  const companyOptions = [
    { value: null, label: "Все компании" },
    ...companies.map((c) => ({ value: c.id, label: c.name })),
  ];

  const columns = [
    { title: "#", dataIndex: "id", width: 60 },
    { title: "Имя", dataIndex: "name", width: 200 },
    {
      title: "Компания",
      dataIndex: "companyId",
      width: 150,
      render: (val) => (val == null ? "Общий" : companies.find((c) => c.id === val)?.name ?? val),
    },
    { title: "Момент", dataIndex: "vid", width: 180, render: getMessagePatternVidName },
    { title: "Дней", dataIndex: "srok", width: 70, align: "right" },
    { title: "Текст", dataIndex: "body", ellipsis: true, render: (v) => (v?.length > 50 ? v.slice(0, 50) + "…" : v) },
    { title: "Активен", dataIndex: "active", width: 80, render: (v) => <Checkbox checked={v} disabled /> },
  ];

  const filtered = filter.showHidden ? items : items.filter((i) => i.active);
  const headerSize = divRef.current?.querySelector(".ant-table-thead")?.offsetHeight ?? 0;
  const tableHeight = divRef.current
    ? document.documentElement.offsetHeight - headerSize - divRef.current.getBoundingClientRect().top - window.scrollY - 1
    : 0;

  const onClose = (refresh) => {
    setEditId(null);
    refresh && getData();
  };

  return (
    <div className="sport-form-content" style={{ display: "flex", flexDirection: "column", height: "100%" }}>
      <div className="sport-form-title">
        <Select
          placeholder="Компания"
          options={companyOptions}
          value={filter.companyId}
          onChange={(v) => setFilter((prev) => ({ ...prev, companyId: v }))}
          style={{ width: 220 }}
          allowClear
        />
        <Checkbox
          checked={filter.showHidden}
          onChange={(e) => setFilter((prev) => ({ ...prev, showHidden: e.target.checked }))}
        >
          Показывать неактивные
        </Checkbox>
        <Button type="primary" onClick={() => setEditId(0)}>
          Новый
        </Button>
        <RefreshButton onClick={getData} />
      </div>
      <div ref={divRef} style={{ flex: 1, minHeight: 0 }}>
        <Table
          dataSource={filtered}
          columns={columns}
          rowKey="id"
          loading={loading}
          size="small"
          pagination={false}
          scroll={{ y: tableHeight }}
          onRow={(record) => ({ onClick: () => setEditId(record.id) })}
        />
      </div>
      {editId != null && <MessagePattern id={editId === 0 ? null : editId} onClose={onClose} companies={companies} />}
    </div>
  );
};

export default MessagePatterns;
